// @ts-nocheck
import Button from "atoms/button/button";
import Card from "atoms/card/card";
import { WaveSvg } from "atoms/icons/navSvg";
import Label from "atoms/label/label";
import Loader from "atoms/loader";
import Sheet from "atoms/sheet/sheet";
import SheetBody from "atoms/sheet/sheetBody/sheetBody";
import Stack from "molecules/stack/stack";
import StackItem from "molecules/stackItem/stackItem";
import moment from "moment";
import * as generateOrderActions from "./generateOrderModal/sagaActions";
import * as generateOrderSelectors from "./generateOrderModal/selectors";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  formatDate,
  formatMoney,
  formatPercentage,
  formatThousands,
} from "utils/utilities";
import * as constants from "./constants";
import * as NewOrerSagaActions from "./newOrders/sagaActions";
import * as sagaActions from "./sagaActions";
import * as selectors from "./selectors";
import * as services from "./services";
import { Typography } from "antd";
import PageLayout from "templates/pageLayout";

const { Title, Text } = Typography;

const today = moment().format("MM/DD/YYYY");

const Home: React.FunctionComponent = ({ title }: any) => {
  const dispatch = useDispatch();
  const openNewOrderModal = useSelector((state) =>
    generateOrderSelectors.isOpen(state)
  );

  const inventoryTableData: any[] = useSelector((state) =>
    selectors.getInventoryTableData(state)
  );

  const statusID: number = useSelector((state) => selectors.getStatusID(state));

  let statusIntervalID = useSelector((state) =>
    selectors.getStatusIntervalID(state)
  );

  const [loading, setLoading] = React.useState(true);
  const [status, updateStatus] = React.useState<string>("orderready");
  const navigate = useNavigate();

  React.useEffect(() => {
    dispatch(sagaActions.loadPage());
    dispatch(sagaActions.getInventoryData());
  }, [dispatch]);

  // const checkStatus = () => {
  // 	services.checkStatus(statusID).then(status => {
  // 		updateStatus(status);
  // 	});
  // };

  // React.useEffect(() => {
  // 	if (statusID) {
  // 		checkStatus();
  // 	}
  // }, [statusID, dispatch]);

  React.useEffect(() => {
    if (inventoryTableData) {
      setLoading(false);
      return;
    }
    // setLoading(false);
  }, [inventoryTableData]);

  const handleGenerateOrderClick = React.useCallback(() => {
    switch (status) {
      case "inprogress":
        // navigate('/orders');
        break;
      case "orderready":
      case "dataready":
      case "complete":
        dispatch(generateOrderActions.setModalView(true));
        break;
      default:
        break;
    }
  }, []);

  const translateAPIData = (rawData) => {
    const formattedData = [];
    rawData.forEach((item) => {
      const newItem = {
        Item: item.SKUID,
        ItemDescription: item.SKUDescription,
        customerName: item.CustomerName,
        initialAvailQty: item.Initial_Available_Qty,
        currentAvailQty: item.Current_Available_Qty,
        percentAvailQtyConsumed: item.Available_Qty_Consumed,
        availCostConsumed: item.Available_Cost_Consumed,
        initialAvailCost: item.Initial_Available_Cost,
        currentAvailCost: item.Current_Available_Cost,
        additionalInfo: "some info",
      };
      formattedData.push(newItem);
    });
    return formattedData;
  };

  const hideNewOrderModal = () => {
    dispatch(NewOrerSagaActions.resetStore());
    setNewOrderModalOpen(false);
  };

  if (loading) {
    return (
      <PageLayout>
        <Stack>
          <StackItem isGrow isStretch align="center">
            <Loader />
          </StackItem>
        </Stack>
      </PageLayout>
    );
  }

  const handleShowMeAvailabilityClick = () => {
    navigate("/availability");
  };

  const statusContent = constants.STATUS_CONTENT[status];

  return (
    <Sheet isPage className="dashboard-page">
      <SheetBody>
        <Stack className="dashboard-card-wrapper">
          <StackItem className="dashboard-card-block">
            <Card>
              <Stack className="card-info">
                <Title level={3}>{statusContent.title || ""}</Title>

                {statusContent.p1 ? (
                  <Title level={5}>{statusContent.p1}</Title>
                ) : (
                  <React.Fragment />
                )}
                {statusContent.p2 ? (
                  <Title level={5}>{statusContent.p2}</Title>
                ) : (
                  <React.Fragment />
                )}
                {statusContent.b1 ? (
                  <StackItem className="card-info-btn">
                    <Button
                      isPrimary
                      data-test-id="generate-order-modal"
                      name={statusContent.b1.text ? statusContent.b1.text : ""}
                      handleClick={() => {
                        navigate("/create");
                      }}
                      // disabled={constants.DISABLED_STATUSES.includes(status)}
                    />
                  </StackItem>
                ) : (
                  <React.Fragment />
                )}
              </Stack>
            </Card>
          </StackItem>
          <StackItem className="dashboard-card-block order-dashboard">
            <Card>
              <Stack className="card-info">
                <Title level={3}>
                  You have{" "}
                  {formatMoney(inventoryTableData?.Current_Available_Cost)} left
                  on your availability
                </Title>
                <Title level={5}>
                  {"You have consumed " +
                    formatPercentage(
                      inventoryTableData?.Available_Qty_Consumed
                    ) +
                    " of your availability."}
                  <br /> Last Updated:{" "}
                  {formatDate(inventoryTableData?.LastUpdate)}
                </Title>
                {/* <Title level={2}>03</Title> */}
                <StackItem className="card-info-btn">
                  <Button
                    isPrimary
                    name="Show Me My Availability"
                    handleClick={handleShowMeAvailabilityClick}
                  />
                </StackItem>
              </Stack>
            </Card>
          </StackItem>
          {/* <StackItem className='dashboard-card-block-full'>
						<Card>
						<Text>Your ad starts on <span>12-01-2024</span> and ends on <span>12-26-2024.</span></Text>
						</Card>					
					</StackItem> */}
        </Stack>
      </SheetBody>
    </Sheet>
  );
};
export default Home;
